module.exports = __webpack_public_path__ + "static/media/circle_05.794983c5.svg";